


























































































































































































import Vue from "vue";
import gameProjectsData from "@/data/GameProjectsData";
import Helpers from "@/helpers";

export default Vue.extend({
  name: "Home",
  data() {
    return {
      projects: gameProjectsData.filter(project => project.featured)
    };
  },
  mounted() {
    Helpers.updateMetadata(
      "EJ Taylan - Game Developer",
      "Game developer portfolio of EJ Taylan - Unity, Unreal Engine, UI/UX, gameplay and audio."
    );

    const requestedSection = Helpers.consumeSectionScroll();
    if (requestedSection) {
      this.$nextTick(() => Helpers.scrollToSection(requestedSection));
    }
  },
  methods: {
    scrollToSection(sectionId: string) {
      Helpers.scrollToSection(sectionId);
    }
  }
});
